<input [ngModel]="selectedDate" (dateChange)="selectedDate.set($event.target.value)" [matDatepicker]="picker">
<button (click)="picker.open()" mat-button class="gp-title-h7 date-picker c-primary">
  Dates
  <mat-icon>calendar_month</mat-icon>
</button>
<mat-datepicker #picker/>
